import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Internal\AreaListingsController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaListingsController.php:21
* @route '/internal-api/areas/property-listings'
*/
export const propertyListings = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: propertyListings.url(options),
    method: 'post',
})

propertyListings.definition = {
    methods: ["post"],
    url: '/internal-api/areas/property-listings',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Internal\AreaListingsController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaListingsController.php:21
* @route '/internal-api/areas/property-listings'
*/
propertyListings.url = (options?: RouteQueryOptions) => {
    return propertyListings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\AreaListingsController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaListingsController.php:21
* @route '/internal-api/areas/property-listings'
*/
propertyListings.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: propertyListings.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Internal\AreaTransactionsController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaTransactionsController.php:21
* @route '/internal-api/areas/property-transactions'
*/
export const propertyTransactions = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: propertyTransactions.url(options),
    method: 'post',
})

propertyTransactions.definition = {
    methods: ["post"],
    url: '/internal-api/areas/property-transactions',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Internal\AreaTransactionsController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaTransactionsController.php:21
* @route '/internal-api/areas/property-transactions'
*/
propertyTransactions.url = (options?: RouteQueryOptions) => {
    return propertyTransactions.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\AreaTransactionsController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaTransactionsController.php:21
* @route '/internal-api/areas/property-transactions'
*/
propertyTransactions.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: propertyTransactions.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Internal\AreaPropertiesController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaPropertiesController.php:19
* @route '/internal-api/areas/properties'
*/
export const properties = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: properties.url(options),
    method: 'post',
})

properties.definition = {
    methods: ["post"],
    url: '/internal-api/areas/properties',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Internal\AreaPropertiesController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaPropertiesController.php:19
* @route '/internal-api/areas/properties'
*/
properties.url = (options?: RouteQueryOptions) => {
    return properties.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\AreaPropertiesController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaPropertiesController.php:19
* @route '/internal-api/areas/properties'
*/
properties.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: properties.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Internal\AreaPolygonsController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaPolygonsController.php:19
* @route '/internal-api/areas/polygons'
*/
export const polygons = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: polygons.url(options),
    method: 'post',
})

polygons.definition = {
    methods: ["post"],
    url: '/internal-api/areas/polygons',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Internal\AreaPolygonsController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaPolygonsController.php:19
* @route '/internal-api/areas/polygons'
*/
polygons.url = (options?: RouteQueryOptions) => {
    return polygons.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Internal\AreaPolygonsController::__invoke
* @see app/Http/Controllers/Api/Internal/AreaPolygonsController.php:19
* @route '/internal-api/areas/polygons'
*/
polygons.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: polygons.url(options),
    method: 'post',
})

const areas = {
    propertyListings: Object.assign(propertyListings, propertyListings),
    propertyTransactions: Object.assign(propertyTransactions, propertyTransactions),
    properties: Object.assign(properties, properties),
    polygons: Object.assign(polygons, polygons),
}

export default areas